export const LABEL_VALUE_MONITORING_GROUP_CART = 'multi_item_cart';
export const LABEL_VALUE_MONITORING_GROUP_CART_COMPUTE = 'multi_item_cart_compute';
export const LABEL_VALUE_MONITORING_GROUP_CART_PAGE = 'multi_item_cart_page';
export const LABEL_VALUE_MONITORING_GROUP_CART_SIDEBAR = 'multi_item_cart_sidebar';
export const LABEL_VALUE_MONITORING_GROUP_CART_ACTION = 'multi_item_cart_action';
export const LABEL_VALUE_MONITORING_GROUP_MULTI_ITEM_ITEM_BUYER = 'multi_item_item_buyer';
export const LABEL_VALUE_MONITORING_GROUP_MULTI_ITEM_DELIVERY = 'multi_item_delivery';
export const LABEL_VALUE_MONITORING_GROUP_MULTI_ITEM_LOAD = 'multi_item_load';
export const LABEL_VALUE_MONITORING_GROUP_MULTI_ITEM_SUBMISSION = 'multi_item_submission';
